import React from 'react';

import LiteralsService from 'src/services/literals/LiteralsService';
import { ButtonPrimary, ButtonSecondary } from '@americanexpress/dls-react';

import styles from './defaultFormButtons.module.scss';

export default function DefaultFormButtons({
    update = false,
    secondaryOnclick
}: {
    update: boolean;
    secondaryOnclick: () => void | Promise<void>;
}): JSX.Element {
    return (
        <div className={styles.buttons}>
            <ButtonPrimary type="submit">
                {LiteralsService.getLiteral(update ? 'CommonText.update' : 'CommonText.add')}
            </ButtonPrimary>
            <ButtonSecondary onClick={secondaryOnclick}>
                {LiteralsService.getLiteral(update ? 'CommonText.delete' : 'CommonText.cancel')}
            </ButtonSecondary>
        </div>
    );
}
